import theme from '../../theme/theme';

const {
  colors: { subtitle, list_number, remove_icon, divider, black_text, list_opacity },
} = theme;

const styles = {
  divider: {
    color: divider,
    borderRadius: 0,
    height: '0.063em',
  },

  scroll__wheel: {
    height: '25em',
    overflow: 'auto',
    position: 'relative',
    flex: 1,
  },

  menuItem__container: {
    height: 'auto',
    padding: 0,
    paddingBottom: '.8em',
    paddingTop: '.8em',
  },

  list__container: {
    display: 'flex',
    width: '100%',
    alignItems: 'baseline',
  },

  index__container: {
    display: 'flex',
    flex: 1,
  },

  left__alphabet: {
    color: list_number,
    fontFamily: 'semibold',
    fontSize: '1.125em',
    height: '1.625em',
    letterSpacing: '-0.031em',
    paddingLeft: '1.438em',
    paddingRight: '1.313em',
  },

  center__container: {
    wordBreak: 'break-word',
    whiteSpace: 'normal',
    width: '75%',
  },

  title__text: {
    alignItems: 'center',
    color: black_text,
    fontSize: '1.5em',
    fontWeight: 'normal',
    letterSpacing: '-0.031em',
  },

  display__flex: {
    display: 'flex',
  },

  subtitle: {
    color: subtitle,
    fontSize: '1.125em',
    fontWeight: 'normal',
    height: '1.625em',
    letterSpacing: '-0.031em',
  },

  dot: {
    paddingLeft: '0.375em',
    paddingRight: '0.375em',
    color: subtitle,
    fontSize: '1.125em',
    fontWeight: 'normal',
    display: 'flex',
    alignItems: 'center',
  },

  close__hour: {
    color: subtitle,
    paddingLeft: '.2em',
    fontSize: '1.125em',
    fontWeight: 'normal',
    height: '1.625em',
    letterSpacing: '-0.031em',
  },

  remove__icon__container: {
    position: 'absolute',
    right: 0,
    top: 0,
    paddingRight: '2.125em',
    paddingTop: '1.3em',
  },

  remove_icon: {
    fontSize: '1.750em',
    color: remove_icon,
  },

  overlay: {
    position: 'fixed',
    left: 0,
    bottom: 0,
    height: '2em',
    width: '100%',
    background: list_opacity,
  },
};

export default styles;
